import React from "react";
import Layout from "@/Layout";
import { get } from "$ACTIONS/TlcRequest";
import { ApiPort } from "$ACTIONS/TLCAPI";
import { Carousel, Icon, Calendar, Skeleton, Button } from "antd";
import { PhotoProvider, PhotoConsumer } from "react-photo-view";
import { getStaticPropsFromStrapiSEOSetting } from "$DATA/seo";

export async function getStaticProps() {
	return await getStaticPropsFromStrapiSEOSetting('/sponsorship'); //參數帶本頁的路徑
}

const linkForMoreVids = "https://www.youtube.com/@FunsportThailand.V2";
const Sponsordata = [
    {
        title: "โทนี่ ปาร์คเกอร์",
        iconImagesUrl: "/th/img/sponsor/logo_Tony.png",
        year: "2023-2024",
        className: "invert",
        style: {},
    },
    {
        title: "อิเกร์ กาซิยาส",
        iconImagesUrl: "/th/img/sponsor/Logo-Iker-1@2x.png",
        year: "2022-2023",
        className: "invert",
        style: {},
    },
    {
        title: "นิวคาสเซิลยูไนเต็ด",
        iconImagesUrl: "/th/img/sponsor/logo_nufc@2x.png",
        year: "2017-2023",
        className: "invert",
        style: {},
    },
    {
        title: "ทอตนัมฮอตสเปอร์",
        iconImagesUrl: "/th/img/sponsor/SPURS@2x.png",
        year: "2012-2023",
        className: "invert",
        style: {
            "navbtn-container": {
                gap: "0px",
            },
        },
    },
    {
        title: "ทีม OG - DOTA 2",
        iconImagesUrl: "/th/img/sponsor/OG@2x.png",
        iconImagesUrlSelected: "/th/img/sponsor/OG-Selected.png",
        year: "2020-2022",
        className: "",
        style: {},
    },
    {
        title: "โคบี ไบรอันต์",
        iconImagesUrl: "/th/img/sponsor/logo_kobe@2x.png",
        year: "2019",
        className: "invert",
        style: {},
    },
    {
        title: "สโมสรฟุตบอล เบิร์นลีย์",
        iconImagesUrl: "/th/img/sponsor/logo_burnley@2x.png",
        iconImagesUrlSelected: "/th/img/sponsor/Burnley-Selected.png",
        year: "2015",
        className: "",
        style: {},
    },
    {
        title: "สตีฟ แนช",
        iconImagesUrl: "/th/img/sponsor/logo_steve@2x.png",
        year: "2014",
        className: "invert",
        style: {},
    },
    {
        title: "รอบบี้ ฟาวเลอร์",
        iconImagesUrl: "/th/img/sponsor/logo_robbie@2x.png",
        year: "2014",
        className: "invert",
        style: {},
    },
];
const Carouseldata = [
    {
        id: 13572,
        style: {},
        bannerImageUrl: "/th/img/sponsor/Banner_TONY.jpg",
        name: "โทนี่ ปาร์คเกอร์", //托尼·帕克
        title: "พอยต์การ์ด บาสเกตบอล NBA",
        content: (
            <>
                <p>
                    เขาเล่นให้กับซานอันโตนิโอสเปอร์สแห่ง NBA ตั้งแต่ปี 2544 ถึง
                    2561
                    <br />
                    ในช่วงระหว่างนั้นเขาได้รับรางวัลมากมาย อาทิเช่น : แชมป์ NBA
                    4 สมัย,
                    <br />
                    MVP NBA Finals 1 สมัย, การคัดเลือก NBA All-Star 6 สมัย,
                    <br />
                    การเลือกทีม All-NBA 4 สมัย และแชมป์ NBA All-Star Challenge 1
                    สมัย
                    <br /> อีกทั้งเขายังเป็นชาวต่างชาติคนแรกที่ชนะ FMVP
                    ในประวัติศาสตร์ NBA Finals
                </p>
            </>
        ),
        otherImagesUrl: [
            "/th/img/sponsor/TonyParker-Gallery-1.jpg",
            "/th/img/sponsor/TonyParker-Gallery-2.jpg",
            "/th/img/sponsor/TonyParker-Gallery-3.jpg",
        ],
        redirect: "",
        contentOfRedirect: "",
    },
    {
        id: 13573,
        style: {},
        bannerImageUrl: "/th/img/sponsor/Banner_IKER.jpg",
        name: "อิเกร์ กาซิยาส", //伊克尔·卡西利亚斯
        title: "FUN88 แบรนด์แอมบาสเดอร์คนใหม่",
        content: (
            <>
                <p>
                    ผู้รักษาประตูในตำนาน, รางวัลชนะบอลโลกฟีฟ่า,
                    รางวัลชนะเลิศยูโรคัพ,
                    <br />
                    รางวัลชนะเลิศยูฟ่าแชมเปี้ยนส์ลีก และอีกมากมาย
                </p>
                <p>
                    “ผมตื่นเต้นที่จะได้เป็นตัวแทนของ FUN88
                    พวกเขาได้สร้างแบรนด์ที่สอดคล้องกับประวัติศาสตร์ฟุตบอลและความหลงใหลในกีฬาฟุตบอล
                    โดยรวมเอาความสนุกของกีฬาผสมผสานกับความบันเทิงในรูปแบบเดียวกันเพื่อคุณโดยเฉพาะ”
                </p>
            </>
        ),
        otherImagesUrl: [
            "/th/img/sponsor/IKER-Gallery-1.png",
            "/th/img/sponsor/IKER-Gallery-2.png",
            "/th/img/sponsor/IKER-Gallery-3.png",
        ],
        redirect: "",
        contentOfRedirect: "",
    },
    {
        id: 13575,
        style: {
            content: {
                marginTop: "23px",
            },
            header: {
                lineHeight: "1.4",
            },
        },
        bannerImageUrl: "/th/img/sponsor/Banner_NUFC.jpg",
        name: "สโมสรฟุตบอล นิวคาสเซิลยูไนเต็ด", //纽卡斯尔联足球俱乐部
        title: "ผู้สนับสนุนหลักอย่างเป็นทางการ ในพรีเมียร์ลีกฤดูกาล",
        content: (
            <>
                <p>
                    2017-2023 และ เป็นหุ้นส่วนอย่างเป็นทางการในเอเชีย
                    <br />
                    ฤดูกาล 2023 จนถึงปัจจุบัน อีกทั้ง FUN88 ยังเป็นผู้นำ
                    <br />
                    ในการสร้างแบรนด์ชั้นนำในเอเชีย
                </p>
                <p>
                    สโมสรฟุตบอลได้ร่วมมือกับ FUN88 ติดต่อกันเป็นเวลา 6 ปี
                    <br />
                    และสร้างชื่อเสียงให้กับทั้งสององค์กรในวงการฟุตบอล
                    <br />
                    ด้วยผลงานที่โดดเด่น และขยายผลสำเร็จอย่างกว้างขวาง
                </p>
            </>
        ),
        otherImagesUrl: [
            "/th/img/sponsor/NUFC-Gallery-1.png",
            "/th/img/sponsor/NUFC-Gallery-2.png",
            "/th/img/sponsor/NUFC-Gallery-3.png",
        ],
        redirect: "", //https://www.nufc.co.uk/news/latest-news/fun88-becomes-newcastle-united-shirt-sponsor/
        contentOfRedirect: "", //进入纽卡斯尔官网
    },
    {
        id: 13576,
        style: {
            content: {
                marginTop: "40px",
            },
            header: {
                lineHeight: "1.4",
            },
        },
        bannerImageUrl: "/th/img/sponsor/Banner_SPURS.jpg",
        name: "สโมสรฟุตบอล ทอตนัมฮอตสเปอร์", //托特纳姆热刺足球俱乐部
        title: "หุ้นส่วนอย่างเป็นทางการในเอเชีย นับจากปี 2012",
        content: (
            <>
                <p>
                    เป็นผู้นำของโลกในการสร้างตำนานฟุตบอล 10 ปีติดต่อกัน
                    <br />
                    ในช่วง 10 ปีที่ผ่านมา สโมสรได้สร้างตำนานพรีเมียร์ลีก
                    และแชมเปียนส์ลีก
                    <br />
                    อย่างต่อเนื่อง
                    การรวมตัวกันครั้งนี้เป็นจุดแข็งในการสร้างภาพลักษณ์ที่ดี
                    <br />
                    สำหรับสององค์กร พร้อมกับอนาคตที่สดใสและก้าวหน้า
                </p>
            </>
        ),
        otherImagesUrl: [
            "/th/img/sponsor/SPURS-Gallery-1.png",
            "/th/img/sponsor/SPURS-Gallery-2.png",
            "/th/img/sponsor/SPURS-Gallery-3.png",
        ],
        redirect: "", //https://www.tottenhamhotspur.com/may-article-import/2018/tottenham-hotspur-extends-relationship-with-fun88/
        contentOfRedirect: "", //进入托特纳姆热刺官网
    },
    {
        id: 13580,
        style: {
            content: {
                marginTop: "21px",
            },
        },
        bannerImageUrl: "/th/img/sponsor/Banner_OG.jpg",
        name: "ทีม OG - DOTA 2",
        title: "2020-2022",
        content: (
            <>
                <p>
                    หุ้นส่วนอย่างเป็นทางการระดับโลก
                    <br />
                    ให้แฟนๆ อีสปอร์ตได้ใกล้ชิดขึ้นอีกขั้น
                </p>
                <p>
                    OG - Dota 2 อีสปอร์ตทีมซุปเปอร์สตาร์
                    ได้จับมือร่วมเป็นหุ้นส่วน
                    <br />
                    อย่างเป็นทางการกับ FUN88 ซึ่ง OG - Dota 2
                    เป็นทีมแรกและทีมเดียว
                    <br />
                    ที่คว้าแชมป์ Dota 2 The International Championship ถึง 2
                    ครั้ง
                    <br />
                    อีกทั้งยังได้รับชัยชนะเป็นทีมแรกในการแข่งขัน Dota 2 Valve
                    Major
                    <br />
                    ติดต่อกันถึง 4 ครั้ง
                </p>
            </>
        ),
        otherImagesUrl: [
            "/th/img/sponsor/OG-Gallery-1.jpg",
            "/th/img/sponsor/OG-Gallery-2.jpg",
            "/th/img/sponsor/OG-Gallery-3.jpg",
        ],
        redirect: "",
        contentOfRedirect: "",
    },
    {
        id: 13574,
        style: {},
        bannerImageUrl: "/th/img/sponsor/Banner_KOBE.jpg",
        name: "โคบี ไบรอันต์", //科比·布莱恩特
        title: "ตำนานนักบาสเกตบอล NBA",
        content: (
            <>
                <p>ทำฝันของคุณให้เป็นจริง กับ FUN88</p>
                <p>
                    โคบี ไบรอันต์ กล่าวว่า
                    "รู้สึกตื่นเต้นและดีใจเป็นอย่างมากที่ได้มีโอกาสร่วมงานกับ
                    FUN88 และสิ่งที่เค้าตื่นเต้นมากที่สุดคือ
                    การทำฝันของคุณให้เป็นจริง"
                </p>
            </>
        ),
        otherImagesUrl: [
            "/th/img/sponsor/KOBE-Gallery-1.png",
            "/th/img/sponsor/KOBE-Gallery-2.png",
            "/th/img/sponsor/KOBE-Gallery-3.png",
        ],
        redirect: "",
        contentOfRedirect: "",
    },
    {
        id: 13577,
        style: {},
        bannerImageUrl: "/th/img/sponsor/Banner_BURNLEY.jpg",
        name: "สโมสรฟุตบอล เบิร์นลีย์", //伯恩利足球俱樂部
        title: "ผู้สนับสนุนเสื้ออย่างเป็นทางการ Burnley F.C ในปี 2015",
        content: (
            <>
                <p>สร้างตำนานแรกแห่งวงการฟุตบอล</p>
                <p>
                    หลังจากทีมได้จับมือกับแบรนด์ FUN88
                    ก็ประสบความสำเร็จอย่างยิ่งใหญ่ และทำได้ถึง 93 แต้ม คว้าแชมป์
                    "แชมเปียนส์ชิพ ลีกอังกฤษ" ซึ่งหมายความว่า
                    ทั้งสององค์กรร่วมกันเพื่อเป็นผู้นำกีฬาออนไลน์และก้าวข้ามจุดสูงสุดในระดับสากล
                </p>
            </>
        ),
        otherImagesUrl: [
            "/th/img/sponsor/BURNLEY-Gallery-1.png",
            "/th/img/sponsor/BURNLEY-Gallery-2.png",
            "/th/img/sponsor/BURNLEY-Gallery-3.png",
        ],
        redirect: "",
        contentOfRedirect: "",
    },
    {
        id: 13578,
        style: {
            content: {
                marginTop: "63px",
            },
        },
        bannerImageUrl: "/th/img/sponsor/Banner_STEVE.jpg",
        name: "สตีฟ แนช", //史蒂夫·納什
        title: "อดีตผู้เล่นทรงคุณค่า 2 สมัย",
        content: (
            <>
                <p>
                    ถึงตาคุณแล้วที่จะปลดล็อกความสนุกตื่นเต้น
                    <br />
                    ในการเป็นสมาชิก FUN88
                </p>
            </>
        ),
        otherImagesUrl: [],
        redirect: "",
        contentOfRedirect: "",
    },
    {
        id: 13579,
        style: {
            content: {
                marginTop: "63px",
            },
        },
        bannerImageUrl: "/th/img/sponsor/Banner_ROBBIE.jpg",
        name: "ร็อบบี้ ฟาวเลอร์",
        title: "ตำนานลิเวอร์พูล",
        content: (
            <>
                <p>
                    รูปแบบที่ดีที่สุด สำหรับการเล่นเกม
                    <br />
                    ในหลากหลายประเภท
                </p>
            </>
        ),
        otherImagesUrl: [],
        redirect: "",
        contentOfRedirect: "",
    },
];

export class Carouselbox extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            indexOfCurrentSponsorPage: this.props.index,
        };
    }

    onChange(a, b, c) {
        console.log(a, b, c);
    }

    // ImageView() {
    //   return (
    //     <PhotoProvider>
    //       {this.props.Carouseldata.otherImagesUrl != "" &&
    //         this.props.Carouseldata.otherImagesUrl.map((item, index) => (
    //           <PhotoConsumer key={index} src={item} intro={item}>
    //             <div className="small_box">
    //               <div className="change_big">点击查看大图</div>
    //               <img
    //                 src={item}
    //                 alt=""
    //                 style={{ width: "140px", height: "90px" }}
    //               />
    //             </div>
    //           </PhotoConsumer>
    //         ))}
    //     </PhotoProvider>
    //   );
    // }

    ImageView(urls) {
        return (
            <PhotoProvider>
                {urls.length != 0 &&
                    urls.map((item, index) => (
                        <PhotoConsumer key={index} src={item}>
                            <div className="small_box">
                                <div className="change_big">
                                    คลิกเพื่อดูภาพขนาดใหญ่
                                </div>
                                {/* 点击查看大图 */}
                                <img
                                    src={item}
                                    alt=""
                                    style={{ width: "140px", height: "90px" }}
                                />
                            </div>
                        </PhotoConsumer>
                    ))}
            </PhotoProvider>
        );
    }

    render() {
        const { indexOfCurrentSponsorPage } = this.state;
        const data = Carouseldata[indexOfCurrentSponsorPage];

        return (
            <div>
                <Carousel afterChange={() => this.onChange} ref={"Carousel"}>
                    <div>
                        <div className="content" key={data.id}>
                            <div className="banner_left">
                                <img src={data.bannerImageUrl} />
                            </div>
                            <div className="banner_right">
                                <div
                                    className="banner_right__sponsorHeader"
                                    style={data.style.header}
                                >
                                    <div className="banner_right__sponsorHeader-name">
                                        {data.name}
                                    </div>
                                    <div className="banner_right__sponsorHeader-title">
                                        {data.title}
                                    </div>
                                </div>
                                <div
                                    className="banner_right__sponsorBody"
                                    style={data.style.content}
                                >
                                    <div
                                        className={
                                            "banner_right__sponsorBody-content"
                                        }
                                        // dangerouslySetInnerHTML={{ __html: data.content }}
                                    >
                                        {data.content}
                                    </div>
                                </div>
                                {data.redirect.trim().length != 0 && (
                                    <Button
                                        className="redirect-to-sponsor"
                                        href={data.redirect}
                                        target="_blank"
                                    >
                                        {data.contentOfRedirect}
                                    </Button>
                                )}
                                <div className="small_banner">
                                    {this.ImageView(data.otherImagesUrl)}
                                </div>
                            </div>
                        </div>
                    </div>
                </Carousel>
            </div>
        );
    }
}
import Router from "next/router";

export default class Main extends React.Component {
    constructor(props) {
        super(props);

        this.sponsortopRef = React.createRef();
        this.state = {
            topactive: 0,
            xCoordOfSponsortop: 0,
            distance: 0,
            // Sponsordata: [],
        };
    }

    componentDidMount() {
        const sponsortop = this.sponsortopRef.current;
        const distance =
            sponsortop.scrollWidth - sponsortop.getBoundingClientRect().width;

        this.setState({ distance });
    }

    Changetopnav(key) {
        this.setState({
            topactive: key,
        });
    }

    slide = (direction) => {
        const sponsortop = this.sponsortopRef.current;
        const { xCoordOfSponsortop, distance } = this.state;
        const oneClick = 218 + 20; // tab width + gap = 238
        let slidedDistance;

        if (direction === "next") {
            slidedDistance = xCoordOfSponsortop - oneClick;
            if (slidedDistance * -1 >= distance) {
                // negative to positive
                slidedDistance = distance * -1; // change back to negatice
            }
        }
        if (direction === "prev") {
            slidedDistance = xCoordOfSponsortop + oneClick;
            if (slidedDistance >= 0) {
                slidedDistance = 0;
            }
        }

        this.setState({ xCoordOfSponsortop: slidedDistance });
        sponsortop.style.left = slidedDistance + "px";
    };

    render() {
        const { topactive, xCoordOfSponsortop, distance } = this.state;

        console.log("dis: ", distance);
        console.log("xCoord: ", xCoordOfSponsortop);

        return (
            <Layout
                seoData={this.props.seoData}
                showFooter={false}
                status={1}
            >
                <div className="common-distance-wrap">
                    <div className="common-distance Sponsorbox">
                        {/* {Sponsordata == "" && <Skeleton active paragraph={{ rows: 1 }} />} */}
                        <div className="top-container">
                            {xCoordOfSponsortop != 0 && (
                                <Button
                                    className="Sponsortop-left-arrow-btn"
                                    onClick={this.slide.bind(this, "prev")}
                                >
                                    <img src="/th/img/sponsor/arrow-left.svg" />
                                </Button>
                            )}
                            <div className="Sponsortop">
                                <div className="Sponsortop-container">
                                    <ul ref={this.sponsortopRef}>
                                        {Sponsordata.map((item, index) => {
                                            return (
                                                <li
                                                    onClick={() => {
                                                        this.setState({
                                                            topactive: index,
                                                        });
                                                    }}
                                                    key={index}
                                                >
                                                    <div
                                                        className={
                                                            topactive == index
                                                                ? "active navbtn"
                                                                : `navbtn ${item.className}`
                                                        }
                                                    >
                                                        <div
                                                            className="navbtn-container"
                                                            style={
                                                                item.style[
                                                                    "navbtn-container"
                                                                ]
                                                            }
                                                        >
                                                            <img
                                                                src={
                                                                    topactive ===
                                                                        index &&
                                                                    item.iconImagesUrlSelected
                                                                        ? item.iconImagesUrlSelected
                                                                        : item.iconImagesUrl
                                                                }
                                                                style={
                                                                    item.style
                                                                        .img
                                                                }
                                                            />
                                                            <div className="navbtn-content">
                                                                <div className="navbtn-content__year">
                                                                    {item.year}
                                                                </div>
                                                                <div className="navbtn-content__title">
                                                                    {item.title}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </div>
                            </div>
                            {xCoordOfSponsortop * -1 < distance && (
                                <Button
                                    className="Sponsortop-right-arrow-btn"
                                    onClick={this.slide.bind(this, "next")}
                                >
                                    <img src="/th/img/sponsor/arrow-right.svg" />
                                </Button>
                            )}
                        </div>
                        <div className="Sponsorbottom">
                            {Sponsordata != "" &&
                                Sponsordata.map((item, index) => {
                                    return (
                                        topactive == index && (
                                            <Carouselbox
                                                Carouseldata={item}
                                                keys={index}
                                                key={index}
                                                index={index}
                                            />
                                        )
                                    );
                                })}
                        </div>
                    </div>
                    <Button
                        className="more-vids-btn"
                        href={linkForMoreVids}
                        target="_blank"
                    >
                        <div className="btn-content-container">
                            <img src="/th/img/sponsor/forMoreVidsYT@2x.png" />
                            <span>ดูวิดีโอเพิ่มเติม</span>
                            {/* 查看更多视频 */}
                        </div>
                    </Button>
                </div>
            </Layout>
        );
    }
}
